export const campaignSteps = ['Definicja promocji', 'Kryteria wyświetlania', 'Wysokość rabatu', 'Emisja', 'Podsumowanie'];

export const couponValidityChoices = [
    { id: 7, name: '7 dni' },
    { id: 14, name: '14 dni' },
    { id: 31, name: '31 dni' },
];
